// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1TukX","content":"ManualTimeModal_content__1_-aS"};